import React, { useState } from 'react';
import Transactions from './Transactions';
import Payments from './Payments';

// Hosts the merged "Transactions" dashboard entry: a single screen that tabs
// between the existing Transactions and Payments lists. Both child components
// are rendered unchanged — this wrapper only owns the tab switcher and defaults
// to the Transactions tab.
function TransactionsTabs({ userSettings, fleetSettings, navigateTo }) {
  const [tab, setTab] = useState('transactions');

  const tabs = [
    { id: 'transactions', label: 'Transactions' },
    { id: 'payments', label: 'Payments' },
  ];

  return (
    <div className="space-y-4">
      {/* Tab switcher */}
      <div className="inline-flex w-full rounded-full bg-white p-1 shadow-sm">
        {tabs.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`flex-1 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
              tab === t.id ? 'bg-blue-700 text-white' : 'text-gray-600'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'transactions' ? (
        <Transactions userSettings={userSettings} fleetSettings={fleetSettings} navigateTo={navigateTo} />
      ) : (
        <Payments userSettings={userSettings} fleetSettings={fleetSettings} navigateTo={navigateTo} />
      )}
    </div>
  );
}

export default TransactionsTabs;
